import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class Animations {
    constructor() {

        this.init();
        ScrollTrigger.refresh();
    }

    init() {

        this.animateTitles();
        this.initParallax('.hero-home .grid_title .parallax');
        this.initParallax('.hero-home .grid_product-cat .deco-top .parallax');
        this.initParallax('.hero-home .grid_product-cat .deco-bottom .parallax');
        this.initParallax('.section-about .grid_image .parallax');
        this.initParallax('.hero-about .grid_image .parallax');
        this.initParallax('.hero-woo-cat .grid_image .thumb-container .parallax');
        this.initParallax('.hero-woo-cat .grid_image .deco .parallax');
        this.animPartnersLogos();

    }

    animateTitles() {
        document.querySelectorAll('.title strong').forEach(title => {
            let mySplitText = new SplitText(title, { type: "chars, words", charsClass: "charClass++" });
            let chars = mySplitText.chars;

            gsap.from(chars, {
                scrollTrigger: {
                    trigger: title.parentNode,
                    start: "top bottom-=15%",
                    toggleActions: "play none none none",
                    // markers: true,
                },
                opacity: .1,
                stagger: .075,
                ease: "back.out(1.7)",
                duration: 1.75
            });
        });
    }

    initParallax(selector) {
        gsap.utils.toArray(selector).forEach((section, i) => {
            const heightDiff = section.offsetHeight - section.parentElement.offsetHeight;
            gsap.timeline({
                scrollTrigger: {
                    trigger: section.parentElement,
                    scrub: true,
                    invalidateOnRefresh: true
                }
            })
                .fromTo(section, {
                    y: -heightDiff
                }, {
                    y: 0,
                    ease: "none"
                });
        });
    }

    animPartnersLogos() {
        gsap.utils.toArray('.section-partners .subgrid_logos .logo').forEach((logo, index) => {
            gsap.from(logo, {
                opacity: 0,
                scale: .5,
                delay: index * .2,
                scrollTrigger: {
                    trigger: logo,
                    start: "top 80%",
                    toggleActions: "play none none none",
                    onEnter: () => {
                        gsap.to('.section-partners .subgrid_logos .logo', {
                            opacity: 1,
                            scale: 1,
                            stagger: 0.2
                        });
                    },
                    // markers: true,
                },
            });
        });
    }
}